import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'In welchem Format erhalte ich die Materialien?',
  a: 'Sie erhalten 11 hochauflösende PDF-Dateien, übersichtlich in Ordnern organisiert. Kompatibel mit jedem Gerät, Tablet, Beamer und Drucker.'
}, {
  q: 'Ist es eine einmalige Zahlung?',
  a: 'Ja. Sie zahlen einmalig und erhalten lebenslangen Zugang zu allen Materialien, inklusive aller zukünftigen Updates. Kein Abonnement, keine versteckten Kosten.'
}, {
  q: 'Für welche Ausbildungsstufe ist das System geeignet?',
  a: 'Das System wurde speziell für die Berufsbildung (EFZ Automatiker, Polymechaniker, Elektroniker), die Berufsmaturität und die technische Sekundarstufe II in der Schweiz entwickelt. Ideal auch für Berufsbildner in Betrieben und Instruktoren in Ausbildungszentren.'
}, {
  q: 'Brauche ich spezielle Hardware oder Software (z.B. Siemens TIA Portal)?',
  a: 'Nein. Das System ist vollständig hardware-unabhängig. Die Übungen sind so konzipiert, dass sie mit kostenloser Simulationssoftware (z.B. PLCSim Advanced Trial, Logixpro) oder direkt am Papier durchgeführt werden können.'
}, {
  q: 'Sind die Inhalte aktuell für Industrie 4.0 und 2026?',
  a: 'Ja, alle Module wurden 2026 nach aktuellem Industrie 4.0 Standard erstellt. SPS-Beispiele basieren auf Siemens SIMATIC S7/TIA Portal, dem in der Schweizer Industrie meistverwendeten System.'
}, {
  q: 'Was ist der Unterschied zwischen Basis- und Experten-System?',
  a: 'Das Experten-System enthält zusätzlich 100 detaillierte reale Schweizer Industriefallstudien (80 Seiten) zu SPS-Programmierung, Sensorik, Pneumatik-Troubleshooting und Industrie 4.0 Projekten mit HMI/SCADA, jeweils mit Sachverhalt, Fragen und Musterlösung.'
}, {
  q: 'Kann ich die PDFs für meine Klasse kopieren und verteilen?',
  a: 'Ja, als Lehrperson oder Berufsbildner dürfen Sie die Materialien für Ihre eigenen Lernenden und Klassen ausdrucken und verteilen. Die Weiterveräusserung an Dritte ist nicht gestattet.'
}, {
  q: 'Eignet sich das System für QV-Vorbereitung (Qualifikationsverfahren)?',
  a: 'Absolut. Die 10 Prüfungsmodelle, 100 Fallstudien und Schaltpläne sind ideal für die QV-Vorbereitung in technischen Berufen wie Automatiker EFZ, Elektroniker und Polymechaniker.'
}, {
  q: 'Wie funktioniert die 7-Tage-Garantie konkret?',
  a: 'Schreiben Sie uns einfach innerhalb von 7 Tagen nach dem Kauf eine kurze E-Mail. Wir erstatten den vollen Kaufpreis umgehend zurück, ohne Rückfragen, ohne Formulare.'
}, {
  q: 'Was passiert nach dem Kauf?',
  a: 'Sofort nach dem Kauf erhalten Sie eine E-Mail mit dem Download-Link zu Ihrem persönlichen Ordner mit allen PDFs. Kein Warten. Kein Versand. Sofort unterrichten.'
}];
export function FAQ() {
  const [openIndex, setIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-brand-card-bg border-y border-gray-200" data-id="element-42">
      <div className="max-w-2xl mx-auto" data-id="element-43">
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-6 text-brand-charcoal" data-id="element-44">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-2.5" data-id="element-45">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-46">
              <button onClick={() => setIndex(openIndex === i ? null : i)} className="w-full px-4 sm:px-5 py-3.5 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-47">
                <span className="font-bold text-brand-charcoal text-[13px] sm:text-base pr-3 leading-snug" data-id="element-48">
                  ❓ {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-200 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              <AnimatePresence data-id="element-50">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-51">
                    <div className="px-4 sm:px-5 pb-4 pt-0 text-gray-600 text-[13px] sm:text-base leading-relaxed" data-id="element-52">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}